import React from 'react';
import Icon from '../../../components/AppIcon';


const ViewToggle = ({ currentView, onViewChange }) => {
  const views = [
    {
      id: 'table',
      label: 'Table View',
      icon: 'Table',
      description: 'Detailed table with sortable columns'
    },
    {
      id: 'cards',
      label: 'Card View',
      icon: 'Grid3X3',
      description: 'Visual cards with key information'
    }
  ];

  return (
    <div className="flex items-center bg-muted rounded-lg p-1">
      {views?.map((view) => (
        <button
          key={view?.id}
          onClick={() => onViewChange(view?.id)}
          className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            currentView === view?.id
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground hover:bg-background/50'
          }`}
          title={view?.description}
        >
          <Icon name={view?.icon} size={16} />
          <span className="hidden sm:inline">{view?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;